var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 22.4,
    height: 16.4,
    rx: 0.78,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "india_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 22.4,
    height: 16.4,
    rx: 0.78,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#india_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.667h23V0H0v5.667z",
    fill: "#FFA44A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17h23v-5.666H0V17z",
    fill: "#1A9F0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.56c1.118 0 2.003-.934 2.003-2.06s-.885-2.06-2.003-2.06-2.003.934-2.003 2.06.885 2.06 2.003 2.06z",
    fill: "#181A93",
    fillOpacity: 0.15,
    stroke: "#181A93",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 8.5,
    rx: 0.548,
    ry: 0.567,
    fill: "#181A93"
  }))));
}
export default SvgIndia;